import type { ReactNode } from 'react';

export type PageTitleProps = {
  heading: string;
  sub?: string;
  actions?: ReactNode;
};

function PageTitle({ heading, sub }: PageTitleProps) {
  return (
    <div className="axi-page-title">
      <h1 className="axi-page-title__heading">{heading}</h1>
      {sub ? <p className="axi-page-title__sub">{sub}</p> : null}
    </div>
  );
}

export default PageTitle;